import { Pipe, PipeTransform, inject } from '@angular/core';

import { AuthService } from '@plugins/client/auth';
import { UserDetailsService } from '@plugins/userdetails-client';

@Pipe({
  name: 'entitledAuthor',
})
export class EntitledAuthorPipe implements PipeTransform {
  private readonly authService = inject(AuthService);
  private userDetailsService = inject(UserDetailsService);

  async transform(ids: string[]): Promise<boolean> {
    const userId = this.authService.userToken.sub;
    return await this.userDetailsService.isUserAuthorized(userId, ids);
  }
}
